@let prestation = $prestation | async;

@if(prestation){

<h1 class="title">{{prestation.nom }}</h1>
<p class="description">{{prestation.descriptionComplete }}</p>

<div class="ateliers-wrapper">
    @for (atelier of $ateliers | async; track $index) {
    <app-carte-atelier [atelier]="atelier" />
    }
</div>
}